const translationMenu =  {
    en: {
        "categories": {
            "pizza": "Pizza",
            "pasta": "Pasta",
            "burger": "Burger",
            "bread": "Bread",
            "sushi": "Sushi",
            "fish": "Fish",
            "hotCoffee": "Hot Coffee",
            "icedCoffee": "Iced Coffee",
            "milkshake": "Milkshake",
            "smoothie": "Smoothie",
            "tea": "Tea",
            "icedTea": "Iced Tea",
            "coldDrink": "Cold Drinks",
            "snack": "Snacks & Sides",
            "pastry": "Pastries & Bakery",
            "dessert": "Dessert",
            "salad": "Salad",
            "mainDishes": "Main Dishes",
            "vegetable": "Vegetable"
        },
        "subcategories": {
            "vegetarianPizza": "Vegetarian Pizza",
            "meatPasta": "Meat Pasta",
            "meatPizza": "Meat Pizza",
            "chickenBurger": "Chicken Burger",
            "beefBurger": "Beef Burger",
            "freshJuice": "Fresh Juice",
            "mediterraneanSalad": "Mediterranean Salad",
            "chocolateDessert": "Chocolate Dessert",
            "traditionalDishes": "Traditional Dishes",
            "chickenDishes": "Chicken Dishes",
            "milkshake": "Milkshake",
            "beefDishes": "Beef Dishes",
            "curry": "Curry",
            "hotCoffee": "Hot Coffee",
            "icedCoffee": "Iced Coffee",
            "greenTea": "Green Tea",
            "blackTea": "Black Tea",
            "herbalTea": "Herbal Tea",
            "lemonade": "Lemonade",
            "icedTea": "Iced Tea",
            "smoothie": "Smoothie",
            "soda": "Soda",
            "healthySnack": "Healthy Snack",
            "dips": "Dips",
            "croissant": "Croissant",
            "muffin": "Muffin",
            "cookie": "Cookie",
            "scone": "Scone",
            "pastryRoll": "Pastry Roll",
            "bread": "Bread"
        },
        "sizes": {
            "Small": "Small",
            "Medium": "Medium",
            "Large": "Large",
            "Standard": "Standard"
        },
        "units": {
            "grams": "grams",
            "ml": "ml"
        },
        "tags": {
            "Classic": "Classic",
            "Vegetarian": "Vegetarian",
            "Spicy": "Spicy",
            "Mexican": "Mexican",
            "Healthy": "Healthy",
            "FastFood": "Fast Food",
            "Popular": "Popular",
            "Grilled": "Grilled",
            "Cheese": "Cheese",
            "Fresh": "Fresh",
            "Sweet": "Sweet",
            "Chocolate": "Chocolate",
            "Mediterranean": "Mediterranean",
            "Premium": "Premium",
            "Vegan": "Vegan",
            "BBQ": "BBQ",
            "Variety": "Variety",
            "Afghan": "Afghan",
            "Bread": "Bread",
            "Assorted": "Assorted",
            "Energy": "Energy",
            "Refreshing": "Refreshing",
            "Chicken": "Chicken",
            "Rice": "Rice",
            "ComfortFood": "Comfort Food",
            "Kebab": "Kebab",
            "Kofta": "Kofta",
            "Onion": "Onion",
            "Salad": "Salad",
            "Corn": "Corn",
            "Egg": "Egg",
            "Breakfast": "Breakfast",
            "Pastry": "Pastry",
            "Sushi": "Sushi",
            "Fusion": "Fusion",
            "Side": "Side",
            "Warm": "Warm",
            "Fried": "Fried",
            "Syrup": "Syrup",
            "SoftDrink": "Soft Drink",
            "Orange": "Orange",
            "Crispy": "Crispy",
            "Liver": "Liver",
            "Lamb": "Lamb",
            "Vegetables": "Vegetables",
            "Light": "Light",
            "Jamaican": "Jamaican",
            "Stew": "Stew",
            "Spiced": "Spiced",
            "Beef": "Beef",
            "Traditional": "Traditional",
            "Indian": "Indian",
            "Italian": "Italian",
            "Nuts": "Nuts",
            "Coffee": "Coffee",
            "HotBeverage": "Hot Beverage",
            "ColdBeverage": "Cold Beverage",
            "Caffeine": "Caffeine",
            "Tea": "Tea",
            "Herbal": "Herbal",
            "Snack": "Snack"
        },
        "ingredients": {
            "Dough": "Dough",
            "Tomato Sauce": "Tomato Sauce",
            "Cheese": "Cheese",
            "Noodles": "Noodles",
            "Ground Beef": "Ground Beef",
            "Herbs": "Herbs",
            "Chicken": "Chicken",
            "Peppers": "Peppers",
            "Onions": "Onions",
            "Fajita Spices": "Fajita Spices",
            "Bell Peppers": "Bell Peppers",
            "Mushrooms": "Mushrooms",
            "Olives": "Olives",
            "Bun": "Bun",
            "Chicken Patty": "Chicken Patty",
            "Lettuce": "Lettuce",
            "Tomato": "Tomato",
            "Sauce": "Sauce",
            "Beef Patty": "Beef Patty",
            "Pickles": "Pickles",
            "Fresh Oranges": "Fresh Oranges",
            "Tomatoes": "Tomatoes",
            "Cucumbers": "Cucumbers",
            "Feta Cheese": "Feta Cheese",
            "Olive Oil": "Olive Oil",
            "Chocolate": "Chocolate",
            "Flour": "Flour",
            "Butter": "Butter",
            "Eggs": "Eggs",
            "Sugar": "Sugar",
            "Walnuts": "Walnuts",
            "Mixed Vegetables": "Mixed Vegetables",
            "Ground Meat": "Ground Meat",
            "Yogurt": "Yogurt",
            "Chickpeas": "Chickpeas",
            "Chicken Breast": "Chicken Breast",
            "Garlic": "Garlic",
            "Banana": "Banana",
            "Milk": "Milk",
            "Ice Cream": "Ice Cream",
            "Chicken Wings": "Chicken Wings",
            "BBQ Sauce": "BBQ Sauce",
            "Spices": "Spices",
            "Beef Steak": "Beef Steak",
            "Vegetables": "Vegetables",
            "Black-Eyed Beans": "Black-Eyed Beans",
            "Curry Spices": "Curry Spices",
            "Coconut Milk": "Coconut Milk",
            "Potatoes": "Potatoes",
            "Green Onions": "Green Onions",
            "Assorted breads": "Assorted breads",
            "Salt": "Salt",
            "Yeast": "Yeast",
            "Carbonated water": "Carbonated water",
            "Caffeine": "Caffeine",
            "Flavorings": "Flavorings",
            "Pepper": "Pepper",
            "Corn": "Corn",
            "Seaweed": "Seaweed",
            "Fish": "Fish",
            "Sesame": "Sesame",
            "Sugar Syrup": "Sugar Syrup",
            "Orange Flavor": "Orange Flavor",
            "Greens": "Greens",
            "Potato": "Potato",
            "Oil": "Oil",
            "Lamb Liver": "Lamb Liver",
            "Berries": "Berries",
            "Greek Yogurt": "Greek Yogurt",
            "Honey": "Honey",
            "Spinach": "Spinach",
            "Parsley": "Parsley",
            "Sea Bass": "Sea Bass",
            "Lemon": "Lemon",
            "Sea Bream": "Sea Bream",
            "Lamb": "Lamb",
            "Rice": "Rice",
            "Raisins": "Raisins",
            "Meat": "Meat",
            "Kidney Beans": "Kidney Beans",
            "Kale": "Kale",
            "Beans": "Beans",
            "Lime": "Lime",
            "Pastry Dough": "Pastry Dough",
            "Cream": "Cream",
            "Carrot": "Carrot",
            "Coffee Beans": "Coffee Beans",
            "Espresso": "Espresso",
            "Whipped Cream": "Whipped Cream",
            "Caramel": "Caramel",
            "Cinnamon": "Cinnamon",
            "Vanilla": "Vanilla",
            "Tea": "Tea",
            "Matcha": "Matcha",
            "Hazelnut Syrup": "Hazelnut Syrup",
            "Green Tea Leaves": "Green Tea Leaves",
            "Black Tea Leaves": "Black Tea Leaves",
            "Bergamot": "Bergamot",
            "Chamomile Flowers": "Chamomile Flowers",
            "Peppermint Leaves": "Peppermint Leaves",
            "Hibiscus Flowers": "Hibiscus Flowers",
            "Strawberries": "Strawberries",
            "Peach Flavor": "Peach Flavor",
            "Mango": "Mango",
            "Apple": "Apple",
            "Ginger": "Ginger",
            "Oats": "Oats",
            "Peanut Butter": "Peanut Butter",
            "Mixed Nuts": "Mixed Nuts",
            "Seeds": "Seeds",
            "Seasonal Fruits": "Seasonal Fruits",
            "Pita Bread": "Pita Bread",
            "Granola": "Granola",
            "Almonds": "Almonds",
            "Blueberries": "Blueberries"
        }
    },
    tr: {
        "categories": {
            "pizza": "Pizza",
            "pasta": "Makarna",
            "burger": "Hamburger",
            "bread": "Ekmek",
            "sushi": "Suşi",
            "fish": "Balık",
            "hotCoffee": "Sıcak Kahve",
            "icedCoffee": "Buzlu Kahve",
            "milkshake": "Milkshake",
            "smoothie": "Smoothie",
            "tea": "Çay",
            "icedTea": "Buzlu Çay",
            "coldDrink": "Soğuk İçecekler",
            "snack": "Atıştırmalıklar",
            "pastry": "Pastane & Fırın",
            "dessert": "Tatlı",
            "salad": "Salata",
            "mainDishes": "Ana Yemekler",
            "vegetable": "Sebze"
        },
        "subcategories": {
            "vegetarianPizza": "Vejetaryen Pizza",
            "meatPasta": "Etli Makarna",
            "meatPizza": "Etli Pizza",
            "chickenBurger": "Tavuk Burger",
            "beefBurger": "Dana Burger",
            "freshJuice": "Taze Meyve Suyu",
            "mediterraneanSalad": "Akdeniz Salatası",
            "chocolateDessert": "Çikolatalı Tatlı",
            "traditionalDishes": "Geleneksel Yemekler",
            "chickenDishes": "Tavuk Yemekleri",
            "milkshake": "Milkshake",
            "beefDishes": "Dana Yemekleri",
            "curry": "Köri",
            "hotCoffee": "Sıcak Kahve",
            "icedCoffee": "Buzlu Kahve",
            "greenTea": "Yeşil Çay",
            "blackTea": "Siyah Çay",
            "herbalTea": "Bitki Çayı",
            "lemonade": "Limonata",
            "icedTea": "Buzlu Çay",
            "smoothie": "Smoothie",
            "soda": "Gazlı İçecek",
            "healthySnack": "Sağlıklı Atıştırmalık",
            "dips": "Dipler",
            "croissant": "Kruvasan",
            "muffin": "Muffin",
            "cookie": "Kurabiye",
            "scone": "Scone",
            "pastryRoll": "Hamur Rulosu",
            "bread": "Ekmek"
        },
        "sizes": {
            "Small": "Küçük",
            "Medium": "Orta",
            "Large": "Büyük",
            "Standard": "Standart"
        },
        "units": {
            "grams": "gram",
            "ml": "ml"
        },
        "tags": {
            "Classic": "Klasik",
            "Vegetarian": "Vejetaryen",
            "Spicy": "Baharatlı",
            "Mexican": "Meksika",
            "Healthy": "Sağlıklı",
            "FastFood": "Fast Food",
            "Popular": "Popüler",
            "Grilled": "Izgara",
            "Cheese": "Peynirli",
            "Fresh": "Taze",
            "Sweet": "Tatlı",
            "Chocolate": "Çikolata",
            "Mediterranean": "Akdeniz",
            "Premium": "Premium",
            "Vegan": "Vegan",
            "BBQ": "Barbekü",
            "Variety": "Çeşitli",
            "Afghan": "Afgan",
            "Bread": "Ekmek",
            "Assorted": "Çeşitli",
            "Energy": "Enerji",
            "Refreshing": "Canlandırıcı",
            "Chicken": "Tavuk",
            "Rice": "Pilav",
            "ComfortFood": "Rahatlatıcı Yemek",
            "Kebab": "Kebap",
            "Kofta": "Köfte",
            "Onion": "Soğan",
            "Salad": "Salata",
            "Corn": "Mısır",
            "Egg": "Yumurta",
            "Breakfast": "Kahvaltı",
            "Pastry": "Hamur Tatlısı",
            "Sushi": "Suşi",
            "Fusion": "Füzyon",
            "Side": "Yan",
            "Warm": "Sıcak",
            "Fried": "Kızarmış",
            "Syrup": "Şurup",
            "SoftDrink": "Gazlı İçecek",
            "Orange": "Portakal",
            "Crispy": "Çıtır",
            "Liver": "Ciğer",
            "Lamb": "Kuzu",
            "Vegetables": "Sebzeler",
            "Light": "Hafif",
            "Jamaican": "Jamaika",
            "Stew": "Güveç",
            "Spiced": "Baharatlı",
            "Beef": "Dana",
            "Traditional": "Geleneksel",
            "Indian": "Hint",
            "Italian": "İtalyan",
            "Nuts": "Ceviz",
            "Coffee": "Kahve",
            "HotBeverage": "Sıcak İçecek",
            "ColdBeverage": "Soğuk İçecek",
            "Caffeine": "Kafein",
            "Tea": "Çay",
            "Herbal": "Bitkisel",
            "Snack": "Atıştırmalık"
        },
        "ingredients": {
            "Dough": "Hamur",
            "Tomato Sauce": "Domates Sosu",
            "Cheese": "Peynir",
            "Noodles": "Makarna",
            "Ground Beef": "Kıyma",
            "Herbs": "Otlar",
            "Chicken": "Tavuk",
            "Peppers": "Biberler",
            "Onions": "Soğanlar",
            "Fajita Spices": "Fajita Baharatları",
            "Bell Peppers": "Tatlı Biberler",
            "Mushrooms": "Mantarlar",
            "Olives": "Zeytin",
            "Bun": "Ekmek",
            "Chicken Patty": "Tavuk Köftesi",
            "Lettuce": "Marul",
            "Tomato": "Domates",
            "Sauce": "Sos",
            "Beef Patty": "Dana Köftesi",
            "Pickles": "Turşu",
            "Fresh Oranges": "Taze Portakallar",
            "Tomatoes": "Domatesler",
            "Cucumbers": "Salatalıklar",
            "Feta Cheese": "Feta Peyniri",
            "Olive Oil": "Zeytinyağı",
            "Chocolate": "Çikolata",
            "Flour": "Un",
            "Butter": "Tereyağ",
            "Eggs": "Yumurtalar",
            "Sugar": "Şeker",
            "Walnuts": "Cevizler",
            "Mixed Vegetables": "Karışık Sebzeler",
            "Ground Meat": "Kıyma",
            "Yogurt": "Yoğurt",
            "Chickpeas": "Nohut",
            "Chicken Breast": "Tavuk Göğsü",
            "Garlic": "Sarımsak",
            "Banana": "Muz",
            "Milk": "Süt",
            "Ice Cream": "Dondurma",
            "Chicken Wings": "Tavuk Kanatları",
            "BBQ Sauce": "Barbekü Sosu",
            "Spices": "Baharatlar",
            "Beef Steak": "Dana Biftek",
            "Vegetables": "Sebzeler",
            "Black-Eyed Beans": "Siyah Göz Fasulyesi",
            "Curry Spices": "Köri Baharatları",
            "Coconut Milk": "Hindistan Cevizi Sütü",
            "Potatoes": "Patatesler",
            "Green Onions": "Yeşil Soğan",
            "Assorted breads": "Çeşitli Ekmekler",
            "Salt": "Tuz",
            "Yeast": "Maya",
            "Carbonated water": "Gazlı Su",
            "Caffeine": "Kafein",
            "Flavorings": "Aromalandırıcılar",
            "Pepper": "Biber",
            "Corn": "Mısır",
            "Seaweed": "Deniz Otu",
            "Fish": "Balık",
            "Sesame": "Susam",
            "Sugar Syrup": "Şeker Şurubu",
            "Orange Flavor": "Portakal Aromı",
            "Greens": "Yeşil Yapraklılar",
            "Potato": "Patates",
            "Oil": "Yağ",
            "Lamb Liver": "Kuzu Ciğeri",
            "Berries": "Meyveler",
            "Greek Yogurt": "Yunan Yoğurdu",
            "Honey": "Bal",
            "Spinach": "Ispanak",
            "Parsley": "Maydanoz",
            "Sea Bass": "Levrek",
            "Lemon": "Limon",
            "Sea Bream": "Çupra",
            "Lamb": "Kuzu",
            "Rice": "Pilav",
            "Raisins": "Üzümler",
            "Meat": "Et",
            "Kidney Beans": "Kırmızı Fasulye",
            "Kale": "Kara Lahana",
            "Beans": "Fasulye",
            "Lime": "Misket Limonu",
            "Pastry Dough": "Hamur",
            "Cream": "Krem",
            "Carrot": "Havuç",
            "Coffee Beans": "Kahve Çekirdekleri",
            "Espresso": "Espresso",
            "Whipped Cream": "Çırpılmış Krema",
            "Caramel": "Karamel",
            "Cinnamon": "Tarçın",
            "Vanilla": "Vanilya",
            "Tea": "Çay",
            "Matcha": "Matcha",
            "Hazelnut Syrup": "Fındık Şurubu",
            "Green Tea Leaves": "Yeşil Çay Yaprakları",
            "Black Tea Leaves": "Siyah Çay Yaprakları",
            "Bergamot": "Bergamot",
            "Chamomile Flowers": "Papatya Çiçekleri",
            "Peppermint Leaves": "Nane Yaprakları",
            "Hibiscus Flowers": "Hibiskus Çiçekleri",
            "Strawberries": "Çilekler",
            "Peach Flavor": "Şeftali Aroması",
            "Mango": "Mango",
            "Apple": "Elma",
            "Ginger": "Zencefil",
            "Oats": "Yulaf",
            "Peanut Butter": "Fıstık Ezmesi",
            "Mixed Nuts": "Karışık Kuruyemiş",
            "Seeds": "Tohumlar",
            "Seasonal Fruits": "Mevsim Meyveleri",
            "Pita Bread": "Pide Ekmeği",
            "Granola": "Granola",
            "Almonds": "Badem",
            "Blueberries": "Yaban Mersini"
        }
    },
    fa: {
        "categories": {
            "pizza": "پیتزا",
            "pasta": "پاستا",
            "burger": "برگر",
            "bread": "نان",
            "sushi": "سوشی",
            "fish": "ماهی",
            "hotCoffee": "قهوه داغ",
            "icedCoffee": "قهوه سرد",
            "milkshake": "میلک‌شیک",
            "smoothie": "اسموتی",
            "tea": "چای",
            "icedTea": "چای سرد",
            "coldDrink": "نوشیدنی‌های سرد",
            "snack": "تنقلات و مزه‌ها",
            "pastry": "شیرینی و نانوایی",
            "dessert": "دسر",
            "salad": "سالاد",
            "mainDishes": "غذاهای اصلی",
            "vegetable": "سبزیجات"
        },
        "subcategories": {
            "vegetarianPizza": "پیتزا گیاهی",
            "meatPasta": "پاستا با گوشت",
            "meatPizza": "پیتزا با گوشت",
            "chickenBurger": "برگر مرغ",
            "beefBurger": "برگر گوشت گاو",
            "freshJuice": "آب میوه تازه",
            "mediterraneanSalad": "سالاد مدیترانه‌ای",
            "chocolateDessert": "دسر شکلاتی",
            "traditionalDishes": "غذاهای سنتی",
            "chickenDishes": "غذاهای مرغ",
            "milkshake": "میلک شیک",
            "beefDishes": "غذاهای گوشت گاو",
            "curry": "کاری",
            "hotCoffee": "قهوه داغ",
            "icedCoffee": "قهوه سرد",
            "greenTea": "چای سبز",
            "blackTea": "چای سیاه",
            "herbalTea": "دمنوش گیاهی",
            "lemonade": "لیموناد",
            "icedTea": "چای سرد",
            "smoothie": "اسموتی",
            "soda": "نوشابه گازدار",
            "healthySnack": "تنقلات سالم",
            "dips": "سس‌ها",
            "croissant": "کروسان",
            "muffin": "مافین",
            "cookie": "کوکی",
            "scone": "اسکون",
            "pastryRoll": "رول شیرینی",
            "bread": "نان"
        },
        "sizes": {
            "Small": "کوچک",
            "Medium": "متوسط",
            "Large": "بزرگ",
            "Standard": "استاندارد"
        },
        "units": {
            "grams": "گرم",
            "ml": "میلی لیتر"
        },
        "tags": {
            "Classic": "کلاسیک",
            "Vegetarian": "گیاهی",
            "Spicy": "تند",
            "Mexican": "مکزیکی",
            "Healthy": "سالم",
            "FastFood": "فست فود",
            "Popular": "محبوب",
            "Grilled": "گریل",
            "Cheese": "پنیری",
            "Fresh": "تازه",
            "Sweet": "شیرین",
            "Chocolate": "شکلات",
            "Mediterranean": "مدیترانه ای",
            "Premium": "درجه یک",
            "Vegan": "گیاهی",
            "BBQ": "باربیکیو",
            "Variety": "متنوع",
            "Afghan": "افغانی",
            "Bread": "نان",
            "Assorted": "متنوع",
            "Energy": "انرژی",
            "Refreshing": "تازه‌کننده",
            "Chicken": "مرغ",
            "Rice": "برنج",
            "ComfortFood": "غذای راحتی",
            "Kebab": "کباب",
            "Kofta": "کوفته",
            "Onion": "پیاز",
            "Salad": "سالاد",
            "Corn": "ذرت",
            "Egg": "تخم مرغ",
            "Breakfast": "صبحانه",
            "Pastry": "شیرینی",
            "Sushi": "سوشی",
            "Fusion": "فیوژن",
            "Side": "کنار",
            "Warm": "گرم",
            "Fried": "سرخ شده",
            "Syrup": "شربت",
            "SoftDrink": "نوشیدنی گازدار",
            "Orange": "پرتقال",
            "Crispy": "ترد",
            "Liver": "جگر",
            "Lamb": "بره",
            "Vegetables": "سبزیجات",
            "Light": "سبک",
            "Jamaican": "جامائیکا",
            "Stew": "خورش",
            "Spiced": "ادویه‌دار",
            "Beef": "گوشت گاو",
            "Traditional": "سنتی",
            "Indian": "هندی",
            "Italian": "ایتالیایی",
            "Nuts": "آجیل",
            "Coffee": "قهوه",
            "HotBeverage": "نوشیدنی داغ",
            "ColdBeverage": "نوشیدنی سرد",
            "Caffeine": "کافئین",
            "Tea": "چای",
            "Herbal": "گیاهی",
            "Snack": "تنقلات"
        },
        "ingredients": {
            "Dough": "خمیر",
            "Tomato Sauce": "سس گوجه‌فرنگی",
            "Cheese": "پنیر",
            "Noodles": "رشته",
            "Ground Beef": "گوشت چرخ شده",
            "Herbs": "سبزی‌های تازه",
            "Chicken": "مرغ",
            "Peppers": "فلفل‌ها",
            "Onions": "پیاز",
            "Fajita Spices": "ادویه‌های فاهیتا",
            "Bell Peppers": "فلفل شیرین",
            "Mushrooms": "قارچ",
            "Olives": "زیتون",
            "Bun": "نان همبرگری",
            "Chicken Patty": "پتی مرغ",
            "Lettuce": "کاهو",
            "Tomato": "گوجه‌فرنگی",
            "Sauce": "سس",
            "Beef Patty": "پتی گوشت",
            "Pickles": "ترشی",
            "Fresh Oranges": "پرتقال تازه",
            "Tomatoes": "گوجه‌فرنگی",
            "Cucumbers": "خیار",
            "Feta Cheese": "پنیر فتا",
            "Olive Oil": "روغن زیتون",
            "Chocolate": "شکلات",
            "Flour": "آرد",
            "Butter": "کره",
            "Eggs": "تخم‌مرغ",
            "Sugar": "شکر",
            "Walnuts": "گردو",
            "Mixed Vegetables": "سبزیجات مخلوط",
            "Ground Meat": "گوشت چرخ شده",
            "Yogurt": "ماست",
            "Chickpeas": "نخود",
            "Chicken Breast": "سینه‌ی مرغ",
            "Garlic": "سیر",
            "Banana": "موز",
            "Milk": "شیر",
            "Ice Cream": "بستنی",
            "Chicken Wings": "بال مرغ",
            "BBQ Sauce": "سس باربیکیو",
            "Spices": "ادویه‌ها",
            "Beef Steak": "استیک گوشت",
            "Vegetables": "سبزیجات",
            "Black-Eyed Beans": "لوبیای چشم‌سیاه",
            "Curry Spices": "ادویه‌های کاری",
            "Coconut Milk": "شیر نارگیل",
            "Potatoes": "سیب‌زمینی",
            "Green Onions": "پیاز سبز",
            "Assorted breads": "نان‌های مختلف",
            "Salt": "نمک",
            "Yeast": "خمیرمایه",
            "Carbonated water": "آب کربنی",
            "Caffeine": "کافئین",
            "Flavorings": "طعم‌دهنده‌ها",
            "Pepper": "فلفل",
            "Corn": "ذرت",
            "Seaweed": "جلبک دریایی",
            "Fish": "ماهی",
            "Sesame": "کنجد",
            "Sugar Syrup": "شربت شکر",
            "Orange Flavor": "طعم پرتقال",
            "Greens": "سبزی‌های برگی",
            "Potato": "سیب‌زمینی",
            "Oil": "روغن",
            "Lamb Liver": "جگر بره",
            "Carrot": "هویج",
            "Berries": "توت‌های جنگلی",
            "Greek Yogurt": "ماست یونانی",
            "Honey": "عسل",
            "Spinach": "اسفناج",
            "Parsley": "جعفری",
            "Sea Bass": "ماهی دریا",
            "Lemon": "لیمو",
            "Sea Bream": "ماهی سفید",
            "Lamb": "بره",
            "Rice": "برنج",
            "Raisins": "کشمش",
            "Meat": "گوشت",
            "Kidney Beans": "لوبیای قرمز",
            "Kale": "کلم فریزی",
            "Beans": "لوبیا",
            "Lime": "لیمو شیرین",
            "Pastry Dough": "خمیر شیرینی",
            "Cream": "خامه",
            "Coffee Beans": "دانه‌های قهوه",
            "Espresso": "اسپرسو",
            "Whipped Cream": "خامه فرم گرفته",
            "Caramel": "کارامل",
            "Cinnamon": "دارچین",
            "Vanilla": "وانیل",
            "Tea": "چای",
            "Matcha": "ماچا",
            "Hazelnut Syrup": "شربت فندق",
            "Green Tea Leaves": "برگ‌های چای سبز",
            "Black Tea Leaves": "برگ‌های چای سیاه",
            "Bergamot": "برگاموت",
            "Chamomile Flowers": "گل‌های بابونه",
            "Peppermint Leaves": "برگ‌های نعناع",
            "Hibiscus Flowers": "گل‌های هیبیسکوس",
            "Strawberries": "توت‌فرنگی",
            "Peach Flavor": "طعم هلو",
            "Mango": "انبه",
            "Apple": "سیب",
            "Ginger": "زنجبیل",
            "Oats": "جو دوسر",
            "Peanut Butter": "کره بادام‌زمینی",
            "Mixed Nuts": "آجیل مخلوط",
            "Seeds": "دانه‌ها",
            "Seasonal Fruits": "میوه‌های فصلی",
            "Pita Bread": "نان پیتا",
            "Granola": "گرانولا",
            "Almonds": "بادام",
            "Blueberries": "بلوبری"
        }
    },
    ar: {
        "categories": {
            "pizza": "بيتزا",
            "pasta": "معكرونة",
            "burger": "برجر",
            "bread": "خبز",
            "sushi": "سوشي",
            "fish": "سمك",
            "hotCoffee": "قهوة ساخنة",
            "icedCoffee": "قهوة مثلجة",
            "milkshake": "ميلك شيك",
            "smoothie": "سموذي",
            "tea": "شاي",
            "icedTea": "شاي مثلج",
            "coldDrink": "مشروبات باردة",
            "snack": "وجبات خفيفة",
            "pastry": "معجنات ومخبوزات",
            "dessert": "حلوى",
            "salad": "سلطة",
            "mainDishes": "أطباق رئيسية",
            "vegetable": "خضروات"
        },
        "subcategories": {
            "vegetarianPizza": "بيتزا نباتية",
            "meatPasta": "معكرونة باللحم",
            "meatPizza": "بيتزا باللحم",
            "chickenBurger": "برجر الدجاج",
            "beefBurger": "برجر اللحم البقري",
            "freshJuice": "عصير طازج",
            "mediterraneanSalad": "سلطة البحر الأبيض المتوسط",
            "chocolateDessert": "حلوى الشوكولاتة",
            "traditionalDishes": "أطباق تقليدية",
            "chickenDishes": "أطباق الدجاج",
            "milkshake": "ميلك شيك",
            "beefDishes": "أطباق اللحم البقري",
            "curry": "كاري",
            "hotCoffee": "قهوة ساخنة",
            "icedCoffee": "قهوة مثلجة",
            "greenTea": "شاي أخضر",
            "blackTea": "شاي أسود",
            "herbalTea": "شاي أعشاب",
            "lemonade": "ليمونادة",
            "icedTea": "شاي مثلج",
            "smoothie": "سموذي",
            "soda": "مشروب غازي",
            "healthySnack": "وجبة صحية خفيفة",
            "dips": "مقبلات",
            "croissant": "كرواسون",
            "muffin": "مافن",
            "cookie": "كوكيز",
            "scone": "سكون",
            "pastryRoll": "لفائف معجنات",
            "bread": "خبز"
        },
        "sizes": {
            "Small": "صغير",
            "Medium": "متوسط",
            "Large": "كبير",
            "Standard": "قياسي"
        },
        "units": {
            "grams": "جرام",
            "ml": "مل"
        },
        "tags": {
            "Classic": "كلاسيكي",
            "Vegetarian": "نباتي",
            "Spicy": "حار",
            "Mexican": "مكسيكي",
            "Healthy": "صحي",
            "FastFood": "وجبات سريعة",
            "Popular": "شائع",
            "Grilled": "مشوي",
            "Cheese": "بالجبن",
            "Fresh": "طازج",
            "Sweet": "حلو",
            "Chocolate": "شوكولاتة",
            "Mediterranean": "متوسطي",
            "Premium": "ممتاز",
            "Vegan": "نباتي",
            "BBQ": "باربكيو",
            "Variety": "متنوع",
            "Afghan": "أفغاني",
            "Bread": "خبز",
            "Assorted": "متنوع",
            "Energy": "طاقة",
            "Refreshing": "منعش",
            "Chicken": "دجاج",
            "Rice": "أرز",
            "ComfortFood": "طعام مريح",
            "Kebab": "كباب",
            "Kofta": "كفتة",
            "Onion": "بصل",
            "Salad": "سلطة",
            "Corn": "ذرة",
            "Egg": "بيض",
            "Breakfast": "إفطار",
            "Pastry": "معجنات",
            "Sushi": "سوشي",
            "Fusion": "اندماج",
            "Side": "جانبي",
            "Warm": "دافئ",
            "Fried": "مقلي",
            "Syrup": "شراب",
            "SoftDrink": "مشروب غازي",
            "Orange": "برتقال",
            "Crispy": "مقرمش",
            "Liver": "كبد",
            "Lamb": "لحم",
            "Vegetables": "خضار",
            "Light": "خفيف",
            "Jamaican": "جامايكي",
            "Stew": "يخنة",
            "Spiced": "متبل",
            "Beef": "لحم",
            "Traditional": "تقليدي",
            "Indian": "هندي",
            "Italian": "إيطالي",
            "Nuts": "مكسرات",
            "Coffee": "قهوة",
            "HotBeverage": "مشروب ساخن",
            "ColdBeverage": "مشروب بارد",
            "Caffeine": "كافيين",
            "Tea": "شاي",
            "Herbal": "أعشاب",
            "Snack": "وجبة خفيفة"
        },
        "ingredients": {
            "Dough": "عجينة",
            "Tomato Sauce": "صلصة الطماطم",
            "Cheese": "الجبن",
            "Noodles": "نودلز",
            "Ground Beef": "لحم مفروم",
            "Herbs": "الأعشاب",
            "Chicken": "دجاج",
            "Peppers": "الفلفل",
            "Onions": "بصل",
            "Fajita Spices": "توابل الفاهيتا",
            "Bell Peppers": "الفلفل الحلو",
            "Mushrooms": "عيش الغراب",
            "Olives": "زيتون",
            "Bun": "كعكة",
            "Chicken Patty": "شطيرة الدجاج",
            "Lettuce": "خس",
            "Tomato": "طماطم",
            "Sauce": "صلصة",
            "Beef Patty": "شطيرة اللحم",
            "Pickles": "مخللات",
            "Fresh Oranges": "برتقال طازج",
            "Tomatoes": "طماطم",
            "Cucumbers": "خيار",
            "Feta Cheese": "جبن فيتا",
            "Olive Oil": "زيت الزيتون",
            "Chocolate": "شوكولاتة",
            "Flour": "دقيق",
            "Butter": "زبدة",
            "Eggs": "بيض",
            "Sugar": "سكر",
            "Walnuts": "الجوز",
            "Mixed Vegetables": "خضار مشكلة",
            "Ground Meat": "لحم مفروم",
            "Yogurt": "لبن",
            "Chickpeas": "حمص",
            "Chicken Breast": "صدر الدجاج",
            "Garlic": "ثوم",
            "Banana": "موز",
            "Milk": "حليب",
            "Ice Cream": "آيس كريم",
            "Chicken Wings": "أجنحة الدجاج",
            "BBQ Sauce": "صلصة الشواء",
            "Spices": "التوابل",
            "Beef Steak": "لحم الشواء",
            "Vegetables": "خضار",
            "Black-Eyed Beans": "الفول الأسود",
            "Curry Spices": "توابل الكاري",
            "Coconut Milk": "حليب جوز الهند",
            "Potatoes": "البطاطس",
            "Green Onions": "البصل الأخضر",
            "Assorted breads": "خبز متنوع",
            "Salt": "ملح",
            "Yeast": "خميرة",
            "Carbonated water": "ماء فوار",
            "Caffeine": "كافيين",
            "Flavorings": "النكهات",
            "Pepper": "فلفل",
            "Corn": "ذرة",
            "Seaweed": "عشب البحر",
            "Fish": "سمك",
            "Sesame": "السمسم",
            "Sugar Syrup": "شراب السكر",
            "Orange Flavor": "نكهة البرتقال",
            "Greens": "الخضر الطازجة",
            "Potato": "بطاطس",
            "Oil": "زيت",
            "Lamb Liver": "كبد الضأن",
            "Berries": "التوت",
            "Greek Yogurt": "اللبن اليوناني",
            "Honey": "عسل",
            "Spinach": "سبانخ",
            "Parsley": "البقدونس",
            "Sea Bass": "قاروس",
            "Lemon": "ليمون",
            "Sea Bream": "أوراد",
            "Lamb": "لحم الضأن",
            "Rice": "أرز",
            "Raisins": "الزبيب",
            "Meat": "لحم",
            "Kidney Beans": "الفاصولياء الحمراء",
            "Kale": "اللفت",
            "Beans": "الفاصولياء",
            "Lime": "الليمون",
            "Pastry Dough": "عجينة الفطائر",
            "Cream": "قشطة",
            "Carrot": "جزر",
            "Coffee Beans": "حبوب القهوة",
            "Espresso": "إسبريسو",
            "Whipped Cream": "كريمة مخفوقة",
            "Caramel": "كراميل",
            "Cinnamon": "قرفة",
            "Vanilla": "فانيليا",
            "Tea": "شاي",
            "Matcha": "ماتشا",
            "Hazelnut Syrup": "شراب البندق",
            "Green Tea Leaves": "أوراق الشاي الأخضر",
            "Black Tea Leaves": "أوراق الشاي الأسود",
            "Bergamot": "برغموت",
            "Chamomile Flowers": "زهور البابونج",
            "Peppermint Leaves": "أوراق النعناع",
            "Hibiscus Flowers": "زهور الكركديه",
            "Strawberries": "فراولة",
            "Peach Flavor": "نكهة الخوخ",
            "Mango": "مانجو",
            "Apple": "تفاح",
            "Ginger": "زنجبيل",
            "Oats": "شوفان",
            "Peanut Butter": "زبدة الفول السوداني",
            "Mixed Nuts": "مكسرات مشكلة",
            "Seeds": "بذور",
            "Seasonal Fruits": "فواكه موسمية",
            "Pita Bread": "خبز بيتا",
            "Granola": "جرانولا",
            "Almonds": "لوز",
            "Blueberries": "توت أزرق"
        }
    },
    el: {
        "categories": {
            "pizza": "Πίτσα",
            "pasta": "Ζυμαρικά",
            "burger": "Μπέργκερ",
            "bread": "Ψωμί",
            "sushi": "Σούσι",
            "fish": "Ψάρι",
            "hotCoffee": "Ζεστός Καφές",
            "icedCoffee": "Παγωμένος Καφές",
            "milkshake": "Μιλκσέικ",
            "smoothie": "Σμούθι",
            "tea": "Τσάι",
            "icedTea": "Παγωμένο Τσάι",
            "coldDrink": "Κρύα Ροφήματα",
            "snack": "Σνακ & Συνοδευτικά",
            "pastry": "Αρτοποιείο",
            "dessert": "Επιδόρπιο",
            "salad": "Σαλάτα",
            "mainDishes": "Κύρια Πιάτα",
            "vegetable": "Λαχανικά"
        },
        "subcategories": {
            "vegetarianPizza": "Χορτοφαγική Πίτσα",
            "meatPasta": "Ζυμαρικά με Κρέας",
            "meatPizza": "Πίτσα με Κρέας",
            "chickenBurger": "Μπέργκερ Κοτόπουλου",
            "beefBurger": "Μπέργκερ Μοσχαριού",
            "freshJuice": "Φρέσκος Χυμός",
            "mediterraneanSalad": "Μεσογειακή Σαλάτα",
            "chocolateDessert": "Επιδόρπιο Σοκολάτας",
            "traditionalDishes": "Παραδοσιακά Πιάτα",
            "chickenDishes": "Πιάτα Κοτόπουλου",
            "milkshake": "Μιλκσέικ",
            "beefDishes": "Πιάτα Μοσχαριού",
            "curry": "Κάρυ",
            "hotCoffee": "Ζεστός Καφές",
            "icedCoffee": "Παγωμένος Καφές",
            "greenTea": "Πράσινο Τσάι",
            "blackTea": "Μαύρο Τσάι",
            "herbalTea": "Βοτανικό Τσάι",
            "lemonade": "Λεμονάδα",
            "icedTea": "Παγωμένο Τσάι",
            "smoothie": "Σμούθι",
            "soda": "Αναψυκτικό",
            "healthySnack": "Υγιεινό Σνακ",
            "dips": "Ντιπ",
            "croissant": "Κρουασάν",
            "muffin": "Μάφιν",
            "cookie": "Μπισκότο",
            "scone": "Σκόουν",
            "pastryRoll": "Ρολό Ζύμης",
            "bread": "Ψωμί"
        },
        "sizes": {
            "Small": "Μικρό",
            "Medium": "Μεσαίο",
            "Large": "Μεγάλο",
            "Standard": "Κανονικό"
        },
        "units": {
            "grams": "γραμμάρια",
            "ml": "μλ"
        },
        "tags": {
            "Classic": "Κλασικό",
            "Vegetarian": "Χορτοφαγικό",
            "Spicy": "Πικάντικο",
            "Mexican": "Μεξικάνικο",
            "Healthy": "Υγιεινό",
            "FastFood": "Γρήγορο Φαγητό",
            "Popular": "Δημοφιλές",
            "Grilled": "Ψητό",
            "Cheese": "Τυρί",
            "Fresh": "Φρέσκο",
            "Sweet": "Γλυκό",
            "Chocolate": "Σοκολάτα",
            "Mediterranean": "Μεσογειακό",
            "Premium": "Premium",
            "Vegan": "Βίγκαν",
            "BBQ": "BBQ",
            "Variety": "Ποικιλία",
            "Afghan": "Αφγανικό",
            "Bread": "Ψωμί",
            "Assorted": "Ποικιλία",
            "Energy": "Ενέργεια",
            "Refreshing": "Ανανεώνον",
            "Chicken": "Κοτόπουλο",
            "Rice": "Ρύζι",
            "ComfortFood": "Άνετο Φαγητό",
            "Kebab": "Kebab",
            "Kofta": "Kofta",
            "Onion": "Κρεμμύδι",
            "Salad": "Σαλάτα",
            "Corn": "Αραβόσιτος",
            "Egg": "Αυγό",
            "Breakfast": "Πρωινό",
            "Pastry": "Ζύμη",
            "Sushi": "Sushi",
            "Fusion": "Σύγχυση",
            "Side": "Πλευρά",
            "Warm": "Ζεστό",
            "Fried": "Τηγανητό",
            "Syrup": "Σιρόπι",
            "SoftDrink": "Αναψυκτικό",
            "Orange": "Πορτοκάλι",
            "Crispy": "Τραγανό",
            "Liver": "Ήπαρ",
            "Lamb": "Αρνί",
            "Vegetables": "Λαχανικά",
            "Light": "Ελαφρύ",
            "Jamaican": "Ιαμαϊκανό",
            "Stew": "Στιφάδο",
            "Spiced": "Μπαχαρικά",
            "Beef": "Μοσχάρι",
            "Traditional": "Παραδοσιακό",
            "Indian": "Ινδικό",
            "Italian": "Ιταλικό",
            "Nuts": "Ξηροί Καρποί",
            "Coffee": "Καφές",
            "HotBeverage": "Ζεστό Ρόφημα",
            "ColdBeverage": "Κρύο Ρόφημα",
            "Caffeine": "Καφεΐνη",
            "Tea": "Τσάι",
            "Herbal": "Βοτανικό",
            "Snack": "Σνακ"
        },
        "ingredients": {
            "Dough": "Ζύμη",
            "Tomato Sauce": "Σάλτσα Ντομάτας",
            "Cheese": "Τυρί",
            "Noodles": "Νούντλς",
            "Ground Beef": "Κιμάς Μοσχαριού",
            "Herbs": "Βότανα",
            "Chicken": "Κοτόπουλο",
            "Peppers": "Πιπεριές",
            "Onions": "Κρεμμύδια",
            "Fajita Spices": "Μπαχαρικά Fajita",
            "Bell Peppers": "Γλυκές Πιπεριές",
            "Mushrooms": "Μανιτάρια",
            "Olives": "Ελιές",
            "Bun": "Ψωμάκι",
            "Chicken Patty": "Κοτόπατή",
            "Lettuce": "Μαρούλι",
            "Tomato": "Ντομάτα",
            "Sauce": "Σάλτσα",
            "Beef Patty": "Κιμοπατή",
            "Pickles": "Τουρσί",
            "Fresh Oranges": "Φρέσκα Πορτοκάλια",
            "Tomatoes": "Ντομάτες",
            "Cucumbers": "Αγγούρια",
            "Feta Cheese": "Τυρί Φέτα",
            "Olive Oil": "Λάδι Ελιάς",
            "Chocolate": "Σοκολάτα",
            "Flour": "Αλεύρι",
            "Butter": "Βούτυρο",
            "Eggs": "Αυγά",
            "Sugar": "Ζάχαρη",
            "Walnuts": "Καρύδια",
            "Mixed Vegetables": "Μικτά Λαχανικά",
            "Ground Meat": "Κιμάς",
            "Yogurt": "Γιαούρτι",
            "Chickpeas": "Ρεβύθια",
            "Chicken Breast": "Στήθος Κοτόπουλου",
            "Garlic": "Σκόρδο",
            "Banana": "Μπανάνα",
            "Milk": "Γάλα",
            "Ice Cream": "Παγωτό",
            "Chicken Wings": "Φτερά Κοτόπουλου",
            "BBQ Sauce": "Σάλτσα BBQ",
            "Spices": "Μπαχαρικά",
            "Beef Steak": "Μπιφτέκι Μοσχαριού",
            "Vegetables": "Λαχανικά",
            "Black-Eyed Beans": "Φασόλια Μαύρο Μάτι",
            "Curry Spices": "Μπαχαρικά Κάρυ",
            "Coconut Milk": "Γάλα Καρύδας",
            "Potatoes": "Πατάτες",
            "Green Onions": "Πράσα",
            "Assorted breads": "Διάφορα Ψωμιά",
            "Salt": "Αλάτι",
            "Yeast": "Μαγιά",
            "Carbonated water": "Ανθρακούχο Νερό",
            "Caffeine": "Καφεΐνη",
            "Flavorings": "Αρωματιστικά",
            "Pepper": "Πιπέρι",
            "Corn": "Αραβόσιτος",
            "Seaweed": "Φύκι",
            "Fish": "Ψάρι",
            "Sesame": "Σουσάμι",
            "Sugar Syrup": "Σιρόπι Ζάχαρης",
            "Orange Flavor": "Γεύση Πορτοκαλιού",
            "Greens": "Χόρτα",
            "Potato": "Πατάτα",
            "Oil": "Λάδι",
            "Lamb Liver": "Ήπαρ Αρνιού",
            "Carrot": "Καρότο",
            "Berries": "Μούρα",
            "Greek Yogurt": "Ελληνικό Γιαούρτι",
            "Honey": "Μέλι",
            "Spinach": "Σπανάκι",
            "Parsley": "Μαϊντανός",
            "Sea Bass": "Λαβράκι",
            "Lemon": "Λεμόνι",
            "Sea Bream": "Τσιπούρα",
            "Lamb": "Αρνί",
            "Rice": "Ρύζι",
            "Raisins": "Σταφίδες",
            "Meat": "Κρέας",
            "Kidney Beans": "Φασόλια Κόκκινες",
            "Kale": "Λάχανο Κάλι",
            "Beans": "Φασόλια",
            "Lime": "Λάιμ",
            "Pastry Dough": "Ζύμη Φύλλου",
            "Cream": "Κρέμα",
            "Coffee Beans": "Κόκκοι Καφέ",
            "Espresso": "Εσπρέσο",
            "Whipped Cream": "Σαντιγύ",
            "Caramel": "Καραμέλα",
            "Cinnamon": "Κανέλα",
            "Vanilla": "Βανίλια",
            "Tea": "Τσάι",
            "Matcha": "Μάτσα",
            "Hazelnut Syrup": "Σιρόπι Φουντουκιού",
            "Green Tea Leaves": "Φύλλα Πράσινου Τσαγιού",
            "Black Tea Leaves": "Φύλλα Μαύρου Τσαγιού",
            "Bergamot": "Περγαμόντο",
            "Chamomile Flowers": "Άνθη Χαμομηλιού",
            "Peppermint Leaves": "Φύλλα Μέντας",
            "Hibiscus Flowers": "Άνθη Ιβίσκου",
            "Strawberries": "Φράουλες",
            "Peach Flavor": "Γεύση Ροδάκινου",
            "Mango": "Μάνγκο",
            "Apple": "Μήλο",
            "Ginger": "Τζίντζερ",
            "Oats": "Βρώμη",
            "Peanut Butter": "Φυστικοβούτυρο",
            "Mixed Nuts": "Μικτοί Ξηροί Καρποί",
            "Seeds": "Σπόροι",
            "Seasonal Fruits": "Εποχιακά Φρούτα",
            "Pita Bread": "Ψωμί Πίτα",
            "Granola": "Γκρανόλα",
            "Almonds": "Αμύγδαλα",
            "Blueberries": "Μύρτιλα"
        }
    },
    ru: {
        "categories": {
            "pizza": "Пицца",
            "pasta": "Паста",
            "burger": "Бургер",
            "bread": "Хлеб",
            "sushi": "Суши",
            "fish": "Рыба",
            "hotCoffee": "Горячий Кофе",
            "icedCoffee": "Кофе со Льдом",
            "milkshake": "Милкшейк",
            "smoothie": "Смузи",
            "tea": "Чай",
            "icedTea": "Холодный Чай",
            "coldDrink": "Холодные Напитки",
            "snack": "Закуски",
            "pastry": "Выпечка",
            "dessert": "Десерт",
            "salad": "Салат",
            "mainDishes": "Основные блюда",
            "vegetable": "Овощи"
        },
        "subcategories": {
            "vegetarianPizza": "Вегетарианская пицца",
            "meatPasta": "Паста с мясом",
            "meatPizza": "Пицца с мясом",
            "chickenBurger": "Куриный бургер",
            "beefBurger": "Говяжий бургер",
            "freshJuice": "Свежий сок",
            "mediterraneanSalad": "Средиземноморский салат",
            "chocolateDessert": "Шоколадный десерт",
            "traditionalDishes": "Традиционные блюда",
            "chickenDishes": "Блюда из курицы",
            "milkshake": "Молочный коктейль",
            "beefDishes": "Блюда из говядины",
            "curry": "Карри",
            "hotCoffee": "Горячий кофе",
            "icedCoffee": "Кофе со льдом",
            "greenTea": "Зелёный Чай",
            "blackTea": "Чёрный Чай",
            "herbalTea": "Травяной Чай",
            "lemonade": "Лимонад",
            "icedTea": "Холодный Чай",
            "smoothie": "Смузи",
            "soda": "Газировка",
            "healthySnack": "Здоровый Перекус",
            "dips": "Дипы",
            "croissant": "Круассан",
            "muffin": "Маффин",
            "cookie": "Печенье",
            "scone": "Сконе",
            "pastryRoll": "Рулет",
            "bread": "Хлеб"
        },
        "sizes": {
            "Small": "Маленький",
            "Medium": "Средний",
            "Large": "Большой",
            "Standard": "Стандартный"
        },
        "units": {
            "grams": "грамм",
            "ml": "мл"
        },
        "tags": {
            "Classic": "Классический",
            "Vegetarian": "Вегетарианское",
            "Spicy": "Острое",
            "Mexican": "Мексиканское",
            "Healthy": "Здоровое",
            "FastFood": "Фаст-фуд",
            "Popular": "Популярное",
            "Grilled": "На гриле",
            "Cheese": "Сыр",
            "Fresh": "Свежее",
            "Sweet": "Сладкое",
            "Chocolate": "Шоколад",
            "Mediterranean": "Средиземноморское",
            "Premium": "Премиум",
            "Vegan": "Веганское",
            "BBQ": "Барбекю",
            "Variety": "Разнообразие",
            "Afghan": "Афганское",
            "Bread": "Хлеб",
            "Assorted": "Ассорти",
            "Energy": "Энергия",
            "Refreshing": "Освежающее",
            "Chicken": "Курица",
            "Rice": "Рис",
            "ComfortFood": "Комфортное питание",
            "Kebab": "Кебаб",
            "Kofta": "Кефта",
            "Onion": "Лук",
            "Salad": "Салат",
            "Corn": "Кукуруза",
            "Egg": "Яйца",
            "Breakfast": "Завтрак",
            "Pastry": "Выпечка",
            "Sushi": "Суши",
            "Fusion": "Фьюжн",
            "Side": "Гарнир",
            "Warm": "Теплое",
            "Fried": "Жареное",
            "Syrup": "Сироп",
            "SoftDrink": "Безалкогольный напиток",
            "Orange": "Апельсин",
            "Crispy": "Хрустящее",
            "Liver": "Печень",
            "Lamb": "Баранина",
            "Vegetables": "Овощи",
            "Light": "Легкое",
            "Jamaican": "Ямайское",
            "Stew": "Рагу",
            "Spiced": "Со специями",
            "Beef": "Говядина",
            "Traditional": "Традиционное",
            "Indian": "Индийское",
            "Italian": "Итальянское",
            "Nuts": "Орехи",
            "Coffee": "Кофе",
            "HotBeverage": "Горячий напиток",
            "ColdBeverage": "Холодный напиток",
            "Caffeine": "Кофеин",
            "Tea": "Чай",
            "Herbal": "Травяной",
            "Snack": "Закуска"
        },
        "ingredients": {
            "Dough": "Тесто",
            "Tomato Sauce": "Томатный соус",
            "Cheese": "Сыр",
            "Noodles": "Лапша",
            "Ground Beef": "Фарш из говядины",
            "Herbs": "Травы",
            "Chicken": "Курица",
            "Peppers": "Перцы",
            "Onions": "Лук",
            "Fajita Spices": "Специи фахита",
            "Bell Peppers": "Сладкий перец",
            "Mushrooms": "Грибы",
            "Olives": "Оливки",
            "Bun": "Булочка",
            "Chicken Patty": "Куриное филе",
            "Lettuce": "Салат",
            "Tomato": "Помидор",
            "Sauce": "Соус",
            "Beef Patty": "Говяжья котлета",
            "Pickles": "Маринованные огурцы",
            "Fresh Oranges": "Свежие апельсины",
            "Tomatoes": "Помидоры",
            "Cucumbers": "Огурцы",
            "Feta Cheese": "Сыр фета",
            "Olive Oil": "Оливковое масло",
            "Chocolate": "Шоколад",
            "Flour": "Мука",
            "Butter": "Масло",
            "Eggs": "Яйца",
            "Sugar": "Сахар",
            "Walnuts": "Грецкие орехи",
            "Mixed Vegetables": "Смешанные овощи",
            "Ground Meat": "Фарш",
            "Yogurt": "Йогурт",
            "Chickpeas": "Нут",
            "Chicken Breast": "Филе курицы",
            "Garlic": "Чеснок",
            "Banana": "Банан",
            "Milk": "Молоко",
            "Ice Cream": "Мороженое",
            "Chicken Wings": "Куриные крылышки",
            "BBQ Sauce": "Соус барбекю",
            "Spices": "Специи",
            "Beef Steak": "Говяжий стейк",
            "Vegetables": "Овощи",
            "Black-Eyed Beans": "Чёрная фасоль",
            "Curry Spices": "Специи карри",
            "Coconut Milk": "Кокосовое молоко",
            "Potatoes": "Картофель",
            "Green Onions": "Зелёный лук",
            "Assorted breads": "Ассортированный хлеб",
            "Salt": "Соль",
            "Yeast": "Дрожжи",
            "Carbonated water": "Газированная вода",
            "Caffeine": "Кофеин",
            "Flavorings": "Ароматизаторы",
            "Pepper": "Перец",
            "Corn": "Кукуруза",
            "Seaweed": "Морские водоросли",
            "Fish": "Рыба",
            "Sesame": "Кунжут",
            "Sugar Syrup": "Сахарный сироп",
            "Orange Flavor": "Апельсиновый вкус",
            "Greens": "Зелень",
            "Potato": "Картофель",
            "Oil": "Масло",
            "Lamb Liver": "Печень ягнёнка",
            "Berries": "Ягоды",
            "Greek Yogurt": "Греческий йогурт",
            "Honey": "Мёд",
            "Spinach": "Шпинат",
            "Parsley": "Петрушка",
            "Sea Bass": "Окунь",
            "Lemon": "Лимон",
            "Sea Bream": "Морской окунь",
            "Lamb": "Баранина",
            "Rice": "Рис",
            "Raisins": "Изюм",
            "Meat": "Мясо",
            "Kidney Beans": "Красная фасоль",
            "Kale": "Кейл",
            "Beans": "Бобы",
            "Lime": "Лайм",
            "Pastry Dough": "Слоёное тесто",
            "Cream": "Сливки",
            "Carrot": "Морковь",
            "Coffee Beans": "Кофейные зёрна",
            "Espresso": "Эспрессо",
            "Whipped Cream": "Взбитые сливки",
            "Caramel": "Карамель",
            "Cinnamon": "Корица",
            "Vanilla": "Ваниль",
            "Tea": "Чай",
            "Matcha": "Матча",
            "Hazelnut Syrup": "Ореховый Сироп",
            "Green Tea Leaves": "Листья Зелёного Чая",
            "Black Tea Leaves": "Листья Чёрного Чая",
            "Bergamot": "Бергамот",
            "Chamomile Flowers": "Цветки Ромашки",
            "Peppermint Leaves": "Листья Мяты",
            "Hibiscus Flowers": "Цветки Гибискуса",
            "Strawberries": "Клубника",
            "Peach Flavor": "Персиковый Вкус",
            "Mango": "Манго",
            "Apple": "Яблоко",
            "Ginger": "Имбирь",
            "Oats": "Овсянка",
            "Peanut Butter": "Арахисовая Паста",
            "Mixed Nuts": "Смешанные Орехи",
            "Seeds": "Семечки",
            "Seasonal Fruits": "Сезонные Фрукты",
            "Pita Bread": "Хлеб Пита",
            "Granola": "Гранола",
            "Almonds": "Миндаль",
            "Blueberries": "Черника"
        }
    }
}

export default translationMenu;